import get from 'lodash/get';
import ProductLabelYear from '@/components/containers/plp/ProductCard/ProductLabelYear';
import ProductCompareButton from '@/components/containers/plp/ProductCard/ProductCompareButton';
import swatchMixin from '@/mixins/swatches.js';
import {PdlSwatchGroup} from '@pedal/pdl-swatch';
import {Url} from '@/utils/url';

export default {
  mixins: [swatchMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    compareButtonEnabled: {
      type: Boolean,
      default: true,
    },
    itemId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ProductLabelYear,
    ProductCompareButton,
    PdlSwatchGroup,
  },

  computed: {
    productUrl() {
      if (!this.product.url) {
        return '';
      }

      let url = Url.withContextPath(this.product.url);
      if (this.currentColor && this.currentColor.length > 0) {
        url += `${url.indexOf('?') > -1 ? '&' : '?'}colorCode=${this.currentColor}`;
      }

      return url;
    },

    productUrlCustomizerOpen() {
      if (!this.product.url) {
        return '';
      }

      let url = Url.withContextPath(this.product.url);
      url += `${url.indexOf('?') > -1 ? '&' : '?'}hasSpectrumOpen=true`;

      return url;
    },

    swatches() {
      if (!Array.isArray(this.product.colorSwatchImageUrl)) {
        return [];
      }

      const colors = this.product.colorSwatchImageUrl.map((item) => {
        let index = item.indexOf('_url=');
        if (index < 0) {
          return {};
        }

        return {
          // name is optional for the swatch group component, but required in
          // this context for changeImage().
          name: item.substring(0, index),
          ...this.processColorCode(item.substring(0, index)),
        };
      });

      // Filter out any empty objects.
      return colors.filter((c) => c.name);
    },

    price() {
      let result = {
        sale: `${this.product.productPriceRange} ${this.bp('excludeTaxText')}`,
        adv: '',
      };

      if (this.product.wasPriceRange && this.product.wasPriceRange !== this.product.productPriceRange) {
        result.adv = `${this.product.wasPriceRange} ${this.bp('excludeTaxText')}`;
      }

      return result;
    },

    isCustomizeVisible() {
      return this.customize && this.product.projectOneUrl;
    },

    isCompareButtonVisible() {
      return this.compareButtonEnabled && !this.product.isArchived;
    },
  },

  methods: {
    changeImage(color) {
      this.currentColor = color?.name;
      if (!this.product.colorSwatchImageUrl) {
        return;
      }

      for (let item of this.product.colorSwatchImageUrl) {
        const keyword = `${this.currentColor}_url=`;
        if (item.indexOf(keyword) > -1) {
          this.currentImageUrl = item.substring(keyword.length);
          return;
        }
      }

      // Fallback to primary image
      this.setPrimaryImage();
    },

    setPrimaryImage() {
      if (!this.product.colorSwatchImageUrl) {
        this.currentImageUrl = get(this.product, 'imageURLList[0]', window.ACC.config.productNoImageUrl);
      }
    },
  },

  mounted() {
    this.setPrimaryImage();
  },

  data() {
    return {
      currentImageUrl: '',
      currentColor: '',
    };
  },
};
